let api_duck = 'https://tgzk-front.tiangezhiku.com/';

export {
  api_duck
}



// WEBPACK FOOTER //
// ./src/assets/js/commt.js